import { Box } from '@mui/material';
import { FC, useState } from 'react';
import { useIntl } from 'react-intl';
import AlertDialog from 'src/app/common/components/AlertDialog';
import AppTabPanel from 'src/app/common/components/AppTabPanel/AppTabPanel';
import { ParamsProps } from 'src/app/common/components/ParamsProvider';
import PruTab from 'src/app/common/components/PruTableTab/PruTab';
import BatchFileList from './components/BatchFileList/BatchFileList';
import HoldPolicyList from './components/HoldPolicyList';

type BatchFilesPageProps = ParamsProps;

const tabMenus = [
  {
    displayName: 'opm_pd.allPolicies',
    value: 0,
    queryValue: 'ALL_POLICY_LIST',
  },
  {
    displayName: 'opm_pd.holdPolicies',
    value: 1,
    queryValue: 'HOLD_POLICY_LIST',
  },
];

const getInitialTabMenuValue = (initialParams?: Record<string, string>) => {
  return tabMenus.find((item) => item.queryValue === initialParams?.tab_menu)?.value ?? tabMenus[0].value;
};

const BatchFilesPage: FC<BatchFilesPageProps> = ({ initialParams }) => {
  const intl = useIntl();
  const Translation = (id: string) => intl.formatMessage({ id });

  const [tabMenuValue, setTabMenuValue] = useState(getInitialTabMenuValue(initialParams));

  return (
    <>
      <PruTab
        itemDef={tabMenus.map((item) => ({
          displayName: Translation(item.displayName),
          value: `${item.value}`,
        }))}
        value={Number(tabMenuValue)}
        onChangeTab={(_, value) => setTabMenuValue(Number(value) || tabMenus[0].value)}
      />
      <Box mb={2} />
      <AppTabPanel index={0} value={tabMenuValue}>
        <BatchFileList />
      </AppTabPanel>
      <AppTabPanel index={1} value={tabMenuValue}>
        <HoldPolicyList />
      </AppTabPanel>
      <AlertDialog />
    </>
  );
};

export default BatchFilesPage;
